"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFound = function NotFound() {
  return _react2.default.createElement(
    "div",
    { className: "grey-section-full not-found" },
    _react2.default.createElement(
      "div",
      { className: "wrapper small" },
      _react2.default.createElement(
        "div",
        { className: "div-block" },
        _react2.default.createElement(
          "h1",
          { className: "_1st-header" },
          "404"
        ),
        _react2.default.createElement("div", { className: "line" })
      ),
      _react2.default.createElement(
        "h2",
        { className: "_2nd-header" },
        "We can't find the page you're looking for."
      ),
      _react2.default.createElement(
        "p",
        { className: "paragraph" },
        "Error code: 404"
      ),
      _react2.default.createElement(
        "p",
        { className: "last" },
        "Try going to our home page, if you still need help contact us at ",
        _react2.default.createElement(
          "a",
          { href: "mailto:admin@entoro.com" },
          "admin@entoro.com"
        )
      )
    )
  );
}; /* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
exports.default = NotFound;